<template>
  <div class="content Tabs">

    <b-tabs card v-model="tabIndex">

      <b-tab :title="lang.tab_Import" :title-link-class="textColors" :title-item-class="textColors"
        :active="tabIndex == 0">
        <b-container class="bv-example-row">

          <b-list-group>
            <b-list-group-item>
              <p>{{ lang.label_description_A0 }}:</p>
              <ul>
                <li>{{ lang.label_description_A1 }}</li>
                <li>{{ lang.label_description_A2 }}</li>

              </ul>
            </b-list-group-item>

          </b-list-group>
          <br>



          <b-form class="file-form">
            {{lang.label_file}}:
            <br><br>
            <b-row>
              <b-col cols="1" class="label-type">{{lang.label_Delimiter}}:</b-col>
              <b-col cols="2">

                <b-form-group id="input-group-Delimiter">
                  <b-form-select size="sm" class="select-delimiter" v-model="delimiter"
                    :options="delimiterOptions"></b-form-select>

                </b-form-group>
              </b-col>
              <b-col cols="7">
                <b-form-file v-model="file" :state="Boolean(file)" :placeholder=lang.placeholder_file
                  drop-placeholder="Drop file here..." class="import-file" accept=".csv" size="sm"
                  :disabled="selectedTreeItemObject.depth==1"></b-form-file>
              </b-col>
              <b-col cols="2">
                <!-- <b-button @click="uploadFile" class="upload-form-button" size="sm" :variant="variant">{{lang.button_Upload}}</b-button> -->



              </b-col>


            </b-row>
            <br>
            <p>{{lang.infotext_1}}: {{selectedTreeItemObject.category}}</p>
            <p><span v-if="selectedTreeItemObject.cisCompatible&& selectedTreeItemObject.depth<3"><b-spinner small
                  label="alert" type="grow" variant="danger"></b-spinner> {{ lang.infotext_4 }}</span><span
                v-if="selectedTreeItemObject.depth==1"><br><b-spinner small label="alert" type="grow"
                  variant="danger"></b-spinner> {{ lang.infotext_6 }}</span></p>
          </b-form>
          <hr v-if="isProps">
          <b-row>
            <b-col cols="3">
              <b-form-checkbox v-if="isProps && currentUser.role=='Admin'" id="allActiveCheckbox" v-model="allActive"
                name="allActiveCheckbox" value="true" unchecked-value="false">
                {{lang.label_AllActive}}
              </b-form-checkbox>
            </b-col>
            <b-col cols="1" class="label-type"><span v-if="isProps">{{lang.label_Type}}:</span></b-col>
            <b-col cols="2">
              <b-form-group v-if="isProps" id="input-group-Type">
                <b-form-select class="select-type" v-model="type" :options="typeOptions"></b-form-select>

              </b-form-group>
            </b-col>
          </b-row>




          <MappingTableComponent v-if="isProps" :lang="lang.TableMapping"></MappingTableComponent>

          <p v-if="!isTable && isProps">{{lang.infotext_Bottom}}</p>

          <p v-if="isTable && !isProps">{{ lang.infotext_notImportedParts }}</p>
          <b-table v-if="isTable&&!isProps" :items="notImportedParts" :fields="tableFields" head-variant=""
            table-variant=""></b-table>

        </b-container>
      </b-tab>

      <b-tab v-if="currentUser.role=='Admin'" :title="lang.tab_PartTypeImport" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 1">
        <b-container class="bv-example-row">

          <b-list-group>
            <b-list-group-item>
              <p>{{ lang.label_description_B0 }}:</p>
              <ul>
                <li>{{ lang.label_description_B1 }}</li>
                <li>{{ lang.label_description_B2 }}</li>

              </ul>
            </b-list-group-item>

          </b-list-group>
          <br>

          <b-form-group id="label-category" label="Enter subcategory in All components:" label-for="input-category"
            class="input-category" description="Create a main category to import items into." required>

            <b-form-input id="input-category" v-model="category" type="text" :placeholder="lang.label_description_B3"
              required></b-form-input>
          </b-form-group>



          <b-form class="file-form">
            {{lang.label_file}}:
            <br><br>
            <b-row>
              <b-col cols="1" class="label-type">{{lang.label_Delimiter}}:</b-col>
              <b-col cols="2">

                <b-form-group id="input-group-Delimiter">
                  <b-form-select size="sm" class="select-delimiter" v-model="delimiter2"
                    :options="delimiter2Options"></b-form-select>

                </b-form-group>
              </b-col>
              <b-col cols="7">
                <b-form-file v-model="filePartType" :state="Boolean(filePartType)" :placeholder=lang.placeholder_file
                  drop-placeholder="Drop file here..." class="import-file" accept=".csv" size="sm"></b-form-file>
              </b-col>
              <b-col cols="2">
                <!-- <b-button @click="uploadFileByPartType" class="upload-form-button" size="sm" :variant="variant">{{lang.button_Upload}}</b-button> -->


              </b-col>

            </b-row>
            <br>
            <p>{{lang.infotext_1}}: All components/{{category}}</p>

          </b-form>
          <hr v-if="isPropsByPartType">


          <b-row>
            <b-col cols="3">
              <b-form-checkbox v-if="isPropsByPartType && currentUser.role == 'Admin'" id="allActivePartTypeCheckbox"
                v-model="allActivePartType" name="allActivePartTypeCheckbox" value="true" unchecked-value="false">
                {{ lang.label_AllActive }}
              </b-form-checkbox>
            </b-col>
            <b-col cols="1" class="label-type"><span v-if="isPropsByPartType">{{ lang.label_Type }}:</span></b-col>
            <b-col cols="2">
              <b-form-group v-if="isPropsByPartType" id="input-group-Type">
                <b-form-select class="select-type" v-model="typePartType" :options="typeOptions"></b-form-select>

              </b-form-group>
            </b-col>
          </b-row>

          <MappingPartTypeTableComponent v-if="isPropsByPartType" :lang="lang.TableMapping">
          </MappingPartTypeTableComponent>
          <p v-if="!isTablePartType && isPropsByPartType">{{lang.infotext_Bottom}}</p>

          <p v-if="isTablePartType && !isPropsByPartType">{{lang.infotext_notImportedParts }}:</p>
          <b-table v-if="isTablePartType && !isPropsByPartType" :items="notImportedParts" :fields="tableFields"
            head-variant="" table-variant=""></b-table>
        </b-container>
      </b-tab>
      <b-tab v-if="currentUser.role == 'Admin'" :title="lang.tab_MixImport" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 2">
        <b-container class="bv-example-row">

          <b-list-group>
            <b-list-group-item>
              <p>{{ lang.label_description_C0 }}:</p>
              <ul>
                <li>{{ lang.label_description_C1 }}</li>
                <li>{{ lang.label_description_C2 }}</li>
                <li>{{ lang.label_description_C3 }}</li>

              </ul>
            </b-list-group-item>

          </b-list-group>
          <br>

          <b-form class="file-form">
            {{ lang.label_file }}:
            <br><br>
            <b-row>
              <b-col cols="1" class="label-type">{{ lang.label_Delimiter }}:</b-col>
              <b-col cols="2">

                <b-form-group id="input-group-Delimiter">
                  <b-form-select size="sm" class="select-delimiter" v-model="delimiter3"
                    :options="delimiter3Options"></b-form-select>

                </b-form-group>
              </b-col>
              <b-col cols="7">
                <b-form-file v-model="fileMix" :state="Boolean(fileMix)" :placeholder=lang.placeholder_file
                  drop-placeholder="Drop file here..." class="import-file" accept=".csv" size="sm"></b-form-file>
              </b-col>
              <b-col cols="2">
                <!-- <b-button @click="uploadFileByPartType" class="upload-form-button" size="sm" :variant="variant">{{lang.button_Upload}}</b-button> -->


              </b-col>

            </b-row>
            <br>
            <p>{{ lang.infotext_5 }}</p>

          </b-form>
          <hr v-if="isPropsMix">


          <b-row>
            <b-col cols="3">
              <b-form-checkbox v-if="isPropsMix && currentUser.role == 'Admin'" id="allActiveMixCheckbox"
                v-model="allActiveMix" name="allActiveMixCheckbox" value="true" unchecked-value="false">
                {{ lang.label_AllActive }}
              </b-form-checkbox>
            </b-col>
            <b-col cols="1" class="label-type"><span v-if="isPropsMix">{{ lang.label_Type }}:</span></b-col>
            <b-col cols="2">
              <b-form-group v-if="isPropsMix" id="input-group-Type">
                <b-form-select class="select-type" v-model="typeMix" :options="typeOptions"></b-form-select>

              </b-form-group>
            </b-col>
          </b-row>

          <MappingMixTableComponent v-if="isPropsMix" :lang="lang.TableMapping"></MappingMixTableComponent>

          <p v-if="!isTableMix && isPropsMix">{{ lang.infotext_Bottom }}</p>

          <p v-if="isTableMix && !isPropsMix">{{ lang.infotext_notImportedParts }}:</p>
          <b-table v-if="isTableMix && !isPropsMix" :items="notImportedParts" :fields="tableFields" head-variant=""
            table-variant=""></b-table>
        </b-container>
      </b-tab>
      <b-tab v-if="currentUser.role=='Admin'" :title="lang.tab_ImportHistory" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 3">
        <b-container class="bv-example-row">

          <ImportHistoryComponent :lang="lang.TableImportHistory"></ImportHistoryComponent>
        </b-container>
      </b-tab>
    </b-tabs>




  </div>

</template>
<script>
import { mapGetters } from 'vuex'



import FormPartPropertiesComponent from '@/components/shared/FormPartPropertiesComponent'
import MappingTableComponent from '@/components/shared/MappingTableComponent'
import ImportHistoryComponent from '@/components/shared/ImportHistoryComponent'
import MappingPartTypeTableComponent from '@/components/shared/MappingPartTypeTableComponent'
import MappingMixTableComponent from '@/components/shared/MappingMixTableComponent'

export default {
  name: "Content",
  components: {
    FormPartPropertiesComponent,
    MappingTableComponent,
    ImportHistoryComponent,
    MappingPartTypeTableComponent,
    MappingMixTableComponent

  },
  props:{
    lang: Object,

  },
  data () {
    return {
      file: null,
      filePartType: null,
      fileMix: null,
      isProps: false,
      isPropsByPartType: false,
      isPropsMix: false,
      isTable: false,
      isTablePartType: false,
      isTableMix: false,
      allActive: false,
      allActivePartType: false,
      allActiveMix: false,
      category: "",
      tabIndex: 0,
      tableFields: ['line', 'values', 'error'],
      typeOptions: [
        { value: "Electric", text: 'Electric' },
        { value: 'Mechanical', text: 'Mechanical' },
        { value: 'Software', text: 'Software' },

      ],
      type: "Electric",
      typePartType: "Electric",
      typeMix: "Electric",
      delimiterOptions: [
        { value: ",", text: ',' },
        { value: ';', text: ';' },
        { value: 'tab', text: '{Tab}' },

      ],
      delimiter: ",",
      delimiter2Options: [
        { value: ",", text: ',' },
        { value: ';', text: ';' },
        { value: 'tab', text: '{Tab}' },

      ],
      delimiter2: ",",
      delimiter3Options: [
        { value: ",", text: ',' },
        { value: ';', text: ';' },
        { value: 'tab', text: '{Tab}' },

      ],
      delimiter3: ","
      
    }
  },
  computed: {
    ...mapGetters({
      selectedTreeItemObject: 'selectedTreeItemObject',
      notImportedParts: 'notImportedParts'

    }),
    currentUser(){
      return this.$store.getters.currentUser;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    }
  },
  created () {
    this.getTabIndex();

  },

  
  watch: {
    file: function () {
      if (this.file != null) {
        this.uploadFile();
      }
      
    },
    filePartType: function () {
      
      if (this.filePartType != null) {
        this.uploadFileByPartType();
      }
      
    },
    fileMix: function () {
      
      if (this.fileMix != null) {
        this.uploadFileMix();
      }
      
    },
    delimiter: function (newVal){
      
      this.$parent.$parent.$parent.setSeparator(newVal);
      if (this.file != null) {
        this.uploadFile();
      }
      
    },
    delimiter2: function (newVal){
      
      this.$parent.$parent.$parent.setSeparator(newVal);
      if (this.filePartType != null) {
        this.uploadFileByPartType();
      }
    },
    delimiter3: function (newVal) {

      this.$parent.$parent.$parent.setSeparator(newVal);
      if (this.fileMix != null) {
        this.uploadFileMix();
      }
    },
    tabIndex: function (newVal) {

      let obj = {};
      obj[this.$route.path + "__middle"] = newVal;

      this.$store.commit("SETTABDATA", obj);

      //####################

      this.file = null;
      this.filePartType = null;
      this.fileMix = null;
      this.isProps = false;
      this.isPropsByPartType = false;
      this.isPropsMix = false;

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_resetMapField");

      this.$parent.$parent.$parent.switchButtons(newVal);
    },
    allActive: function() {

      const obj = {
        allActive: this.allActive,
        type: this.type
      }
      
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_setAllActiveImportedParts", obj);
    },
    allActivePartType: function () {

      const obj = {
        allActive: this.allActivePartType,
        type: this.typePartType
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_setAllActiveImportedParts", obj);
    },
    allActiveMix: function () {

      const obj = {
        allActive: this.allActiveMix,
        type: this.typeMix
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_setAllActiveImportedParts", obj);
    },
    type: function() {

      const obj = {
        allActive: this.allActive,
        type: this.type
      }
      
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_setAllActiveImportedParts", obj);
    },
    typePartType: function () {

      const obj = {
        allActive: this.allActivePartType,
        type: this.typePartType
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_setAllActiveImportedParts", obj);
    },
    typeMix: function () {

      const obj = {
        allActive: this.allActiveMix,
        type: this.typeMix
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_setAllActiveImportedParts", obj);
    },
    notImportedParts: function(newVal){

      if (newVal.length == 0){
        this.isTable = false;
        this.isTablePartType = false;
        this.isTableMix = false;
      }else{
        this.isProps = false;
        this.isPropsByPartType = false;
        this.isPropsMix = false;
        this.isTable = true;
        this.isTablePartType = true;
        this.isTableMix = true;
      }
    },
    category: function(newVal){
      this.$store.dispatch("setNewSubCategory", newVal);
    }
  

  },
  methods: {
    getTabIndex() {
      

      if (this.$store.getters.tabData[this.$route.path + "__middle"] != undefined) {
        this.tabIndex = this.$store.getters.tabData[this.$route.path + "__middle"];
      } else {
        this.tabIndex = 0;
      }

    },
    uploadFile(){
      
      let _vue = this;

      let obj = {
        file: {file: this.file},
        separator: this.delimiter
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_importFileWithParts", obj)
      .then(function(result) {
        
        
        if (result.status == "OK") {
          if (result.data.Data != null) {

            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setPreviewParts", result.data.Data);
            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setImportedFileId", result.data.fileId);
            _vue.isProps = true;

            const obj = {
              text: _vue.lang.alert_success_importParts,
              time: 10,
              type: "success"
            }
            _vue.$store.dispatch("displayFooterAlert", obj);
          } else {
            const obj = {
              text: _vue.lang.alert_error_importParts + ".",
              time: 15,
              type: "danger"
            }


            _vue.$store.dispatch("displayFooterAlert", obj);
          }
        } else {
          const obj = {
            text: _vue.lang.alert_error_importParts + ": " + result.message,
            time: 15,
            type: "danger"
          }


          _vue.$store.dispatch("displayFooterAlert", obj);
        }
        



      })

    },
    uploadFileByPartType(){
          

      let _vue = this;

      let obj = {
        file: {file: this.filePartType},
        separator: this.delimiter2
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_importFileWithParts", obj)
      .then(function(result) {
        
        console.log(result.data)
        
       
        if (result.status == "OK") {
          if (result.data.Data != null) {

            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setPreviewParts", result.data.Data);
            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setImportedFileId", result.data.fileId);
            _vue.isPropsByPartType = true;

            const obj = {
              text: _vue.lang.alert_success_importParts,
              time: 10,
              type: "success"
            }
            _vue.$store.dispatch("displayFooterAlert", obj);
          } else {
            const obj = {
              text: _vue.lang.alert_error_importParts + ".",
              time: 15,
              type: "danger"
            }


            _vue.$store.dispatch("displayFooterAlert", obj);
          }
        } else {
          const obj = {
            text: _vue.lang.alert_error_importParts + ": " + result.message,
            time: 15,
            type: "danger"
          }


          _vue.$store.dispatch("displayFooterAlert", obj);
        }



      })

    },
    uploadFileMix() {

      let _vue = this;

      let obj = {
        file: { file: this.fileMix },
        separator: this.delimiter3
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_importFileWithParts", obj)
        .then(function (result) {


          if (result.status == "OK") {
            if (result.data.Data != null) {

              _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setPreviewParts", result.data.Data);
              _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setImportedFileId", result.data.fileId);
              _vue.isPropsMix = true;

              const obj = {
                text: _vue.lang.alert_success_importParts,
                time: 10,
                type: "success"
              }
              _vue.$store.dispatch("displayFooterAlert", obj);
            } else {
              const obj = {
                text: _vue.lang.alert_error_importParts + ".",
                time: 15,
                type: "danger"
              }


              _vue.$store.dispatch("displayFooterAlert", obj);
            }
          } else {
            const obj = {
              text: _vue.lang.alert_error_importParts + ": " + result.message,
              time: 15,
              type: "danger"
            }


            _vue.$store.dispatch("displayFooterAlert", obj);
          }




        })

    },
  },
  
}
</script>

<style lang="scss">

  .Tabs{
    .bv-example-row-max{
      max-width: 100%;
      padding-right: 0px;
      padding-left: 0px;
    }

    .file-form{
      width: 80%;
    }

    .upload-form-button{

      margin-left: 10px;
      margin-top: 2px;
    }
    .spinner-import{
      margin-left: 20px;
    }
    .input-category{
      width: 300px;
      
    }
    .select-type{
      max-width: 200px;
      height: 26px;
      font-size: 0.75rem;
      padding-top: 2px;
    }
    .label-type{
      text-align: right;
    }
    .select-delimiter{
      width: 70px;
    }
    .import-file{

      //width: 300px;
    }
  }




</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartImport/Middle/Content/Content.vue